import { useState } from "react";

export type LoadingStepData = {
  type: string;
  content: string;
} | null;

export const useAssistantLoaderState = () => {
  const [isChatLoading, setIsChatLoading] = useState<boolean>(false);
  const [loadingStepData, setLoadingStepData] = useState<LoadingStepData>(null);

  return {
    isChatLoading,
    setIsChatLoading,
    loadingStepData,
    setLoadingStepData,
  };
};
